import { fg } from '@atlaskit/platform-feature-flags';
import { performGqlFetch } from '@atlassian/conversation-assistant-utils/graphqlUtils';

import { type CloudIdResponse, type CloudIdVariables } from './types.ts';

const CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const cache = new Map<string, CloudIdResponse['tenantContexts'][0]>();

export const getCloudUrlFromId = async (cloudId: string): Promise<{
    cloudUrl: string;
    orgId: string;
} | undefined> => {
	// If AIFC is enabled, use the new caching
	if (fg('aifc_create_enabled')) {
		// Check if we already have a pending promise or cached result
		if (cache.has(cloudId)) {
			return cache.get(cloudId);
		}

		const response = await performGqlFetch<CloudIdResponse, CloudIdVariables>({
			gqlQuery: CloudIdLookupQuery,
			variables: {
				cloudIds: [cloudId],
			},
		});

		const result = response.data?.tenantContexts?.[0];

		if (result) {
			// Store the promise in the cache
			cache.set(cloudId, result);
		}

		return result;
	}

	const response = await performGqlFetch<CloudIdResponse, CloudIdVariables>({
		gqlQuery: CloudIdLookupQuery,
		variables: {
			cloudIds: [cloudId],
		},
	});
	return response.data?.tenantContexts?.[0];
};
